import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AuthLink } from "./interfaces";
import { adminNavigation, userNavigation } from "./menus";
import useAuth from "../../hooks/useAuth";
import { userIsAdmin } from "../../models/user";
import CredentalLogo from "../../icons/credentalLogo";
import { useNavigate, useLocation } from 'react-router-dom'
import statesService from "../../Services/states.service";
import credentialService from "../../Services/credential.services";
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { sidebarStore } from "../../screens/store/SidebarStore";
import { observer } from "mobx-react-lite";


const SideBar = observer(() => {
  const { user, signout } = useAuth();
  const [menu, setMenu] = useState<AuthLink[]>([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState<AuthLink>();

  const logOut = async () => {
    await signout();
    window.localStorage.clear();
    navigate("/login");
  };

  useEffect(() => {
    const navigation = userIsAdmin(user) ? adminNavigation : userNavigation;
    setMenu([...navigation]);
    // Highlight the item for the page we are actually on, not always the first one
    setActiveMenu(navigation.find((item) => item.href === location.pathname) ?? navigation[0]);
  }, [user, location.pathname]);

  useEffect(() => {
    const handleCredentialNewRequest = async () => {
      try {
        const canNewRequest = await statesService.GetCredentialNewRequestStatus();
        sidebarStore.setCanCreateNewRequest(canNewRequest.data);
      } catch (error) {
        console.error("Error checking request status:", error);
      }
    };
    handleCredentialNewRequest();
  }, []);

  useEffect(() => {
    if (userIsAdmin(user)) {
      return;
    }
    const checkPaymentDue = async () => {
      try {
        const nextPage = await credentialService.GetNextPage();
        sidebarStore.setOwesPayment(nextPage === "plans");
      } catch (error) {
        console.error("Error checking payment status:", error);
      }
    };
    checkPaymentDue();
  }, [user, location.pathname]);

  return (
    <div className="bg-white min-h-screen w-56 text-black flex-shrink-0 border-r border-solid border-grey-200">
      {/* Logo */}
      <div className="mb-2 px-7 py-2 border-b border-grey-200 h-16 flex items-center">
        <CredentalLogo width={150} />
      </div>
      {/* Navigation */}
      <div className="px-3 py-4 flex flex-col">
        {menu.map((item, i) => {
          // Dynamically handle New Credentialing Request or Change Insurance Companies
          if (
            (sidebarStore.canCreateNewRequest && item.name === "Change Insurance Companies") ||
            (!sidebarStore.canCreateNewRequest && item.name === "New Credentialing Request")
          ) {
            return null;
          }

          // Only show Payment in the menu when the dentist currently owes a payment
          if (item.name === "Payment" && !sidebarStore.owesPayment) {
            return null;
          }

          return (
            <Link to={item.href} key={i}>
              <div
                id={"div_" + i}
                onClick={() => setActiveMenu(item)}
                className={`flex text-base items-center py-2 px-4 rounded mb-1 cursor-pointer transition-all ease-out duration-200 hover:text-primary-500 ${
                  activeMenu === item && "bg-primary-50 text-primary-500 font-bold"
                }`}
              >
                <div className="w-5 mr-3">{item.icon}</div>
                {item.name === "Log out" ? (
                  <p className="font-regular" onClick={logOut}>
                    {item.name}
                  </p>
                ) : (
                  <p className="font-regular">{item.name}</p>
                )}
              </div>
            </Link>
          );
        })}
      </div>
      <ToastContainer />
    </div>
  );
})
export default SideBar
